import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {DataService} from "../../services/data.service";
import {Store} from "@ngrx/store";
import {AppState} from "../../store";
import {toggleSelfAssessedRequirement} from "../../store/actions/user.actions";
import {getSelfAssessedRequirements} from "../../store/selectors/user.selector";
import {Overlayable} from "../../interfaces/overlayable";
import {SelfAssessmentService} from "./self-assessment.service";
import {RequirementType} from "../../interfaces/requirement-type";
import {SelfAssessedReqRow} from "../../interfaces/self-assessed-req-row";
import {IconsService} from "../../services/icons.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
  selector: 'brt-self-assessment',
  templateUrl: './self-assessment.component.html',
  styleUrls: ['./self-assessment.component.scss']
})
export class SelfAssessmentComponent implements Overlayable {

  @Output('onClosed') onClosed = new EventEmitter<boolean>();

  activeSlide = 0;
  requirementTypes: RequirementType[] = [];
  currentUserSelfAssessmentState: SelfAssessedReqRow[] = []

  constructor(
    private data: DataService,
    private store: Store<AppState>,
    private selfAssessment: SelfAssessmentService,
    private iconService: IconsService
  ) { }

  ngOnInit() {

    this.selfAssessment.getRequirementsList().pipe(untilDestroyed(this)).subscribe((list) => {
      if(list) {
        this.requirementTypes = list;
      }
    })

    this.selfAssessment.onCurrentPageNumberChanged().pipe(untilDestroyed(this)).subscribe((val) => {
      this.activeSlide = val;
    });

    this.store.select(getSelfAssessedRequirements()).pipe(untilDestroyed(this)).subscribe((requirements) => {
      this.currentUserSelfAssessmentState = requirements;
    });
  }

  toggleOption(bicId: number, reqId: number) {
    this.store.dispatch(toggleSelfAssessedRequirement({bicId: bicId, requirementId: reqId}));
  }

  isSelected(bicId: number, reqId: number) {
    const bicIdRow = this.currentUserSelfAssessmentState.filter((row) => row.bicId === bicId);
    if(bicIdRow.length === 0) return false;

    return bicIdRow[0].reqIds.includes(reqId);
  }

  getIconById(id: number): string {
    return this.iconService.getRequirementIconById(id);
  }

}
